import React from "react";
import { Link } from "react-router-dom";
import { useSite } from "@/i18n/SiteContext";
import { Checkbox } from "@/components/ui/checkbox";

/* GDPR consent checkbox shared by every public form. The label links to the privacy notice page. */
export const PrivacyConsent = ({ checked, onChange, testId = "privacy-consent", textKey = "consent.contact" }) => {
  const { t } = useSite();
  const text = t(textKey);
  const [before, after] = text.split("{link}");
  return (
    <label className="flex items-start gap-3 text-xs text-ocean/70 leading-relaxed cursor-pointer" data-testid={`${testId}-label`}>
      <Checkbox checked={checked} onCheckedChange={(v) => onChange(!!v)} className="mt-0.5" data-testid={`${testId}-checkbox`} />
      <span>
        {before}
        <Link to="/privacy" target="_blank" rel="noopener noreferrer" className="underline underline-offset-4 text-sea hover:text-ocean" data-testid={`${testId}-link`}>{t("consent.link")}</Link>
        {after} *
      </span>
    </label>
  );
};
